/* istanbul ignore file */
import React, { useEffect, useState, useReducer, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ApiSession from "../api/ApiSession";
import embLabels from "../config/emb-labels-en.json";
import SecureTableHeading from "./SecureArchitecture/SecureTableHeading";
import SecureCommunicationTable from "./SecureArchitecture/SecureCommunicationTable";
import MoxaCommunicationTable from "./SecureArchitecture/MoxaCommunicationTable";
import VlanTableHeading from "./SecureArchitecture/VlanTableHeading";
import { fortiGateVlanHeaders, moxaVlanHeaders } from "../utils/constants";
const apiSession = new ApiSession();
// ACTIONS

export const ACTIONS = {
  FETCH_SUCCESS: "FETCH_SUCCESS",
  ENABLE_TEXTBOX: "ENABLE_TEXTBOX",
  ENABLE_TEXTBOX_SYSTEM: "ENABLE_TEXTBOX_SYSTEM",
  RESET_COMMUNICATION: "RESET_COMMUNICATION",
};

const SecureArchitectureHook = (props) => {
  let userSampleData = {
    name: "",
    role: "",
    access: "",
  };

  let userScope =
    JSON.parse(localStorage.getItem("scope")) !== null
      ? JSON.parse(localStorage.getItem("scope"))
      : userSampleData;
  const [UserScope] = useState(userScope);
  const [loading, setLoading] = useState(false);
  
  const [snackBar, setSnackBar] = useState({ type: "", message: "" });
 
  // const secureArchitectureData = useSelector(
  //   (state) => state?.secureArchitectureData?.data
  // );
  const [secureCommunicationData, setSecureCommunicationData] = useState();
  const [vlanConfiguration, setVlanConfiguration] = useState("fortigate");
  const [memberTypeList, setMemberTypeList] = useState(["ACCESS","HYBRID_TRUNK"]);
  const [interfaceTypeListFortigate, setInterfaceTypeListFortigate] = useState(["VLAN_SWITCH","LAN","WAN"]);
  const [interfaceTypeListFortigateConexium, setInterfaceTypeListFortigateConexium] = useState(["VLAN","TRUNK"]);
  const [wanSelected, setWanSelected] = useState(false);
  // Track taken VLAN accessMembers for VLAN_SWITCH ports as a Set
  const [vlanSwitchTakenAccessMembers, setVlanSwitchTakenAccessMembers] = useState(new Set());
 useEffect(()=>{
  if(props?.secureArchitectureData){
     const hasWAN  = props?.secureArchitectureData?.fortigateVlanConfigurations?.some(item => item.memberType === "WAN");
    setWanSelected(hasWAN);
  }
  setSecureCommunicationData(props?.secureArchitectureData);
  setVlanConfiguration(props?.secureArchitectureData?.gatewayType);
 },[props?.secureArchitectureData])
 
  useEffect(() => {
    const projectId = props && props?.projectId
    if (!projectId) {
      let { history } = props;
      history?.push({
        pathname: `${"/information"}/${projectId}`,
      });
    }
  }, []);

  const saveSecureCommunicationData = () => {
    setLoading(true);
    const secureArchitectureDataJSON = {
      ...secureCommunicationData,
      gatewayType:vlanConfiguration,
    }
    apiSession
      .upDataSecureArchitectureData(secureArchitectureDataJSON)
      .then((response) => {
        if(response){
          setSecureCommunicationData(response);
          setLoading(false);
        }
        
        callSnackbar(
          "success",
          "Secure communication settings updated successfully"
        );
      });
  };
  const computeVlanSwitchTakenAccessMembers = useCallback((overridePort = null, overrideVlan = null, overrideConfigs = null) => {
    // Prefer latest state (secureCommunicationData) over props after initial load.
    // Allow caller to pass freshly updated configuration array via overrideConfigs for accuracy.
    const source = overrideConfigs
      ? overrideConfigs
      : (secureCommunicationData?.fortigateVlanConfigurations || props?.secureArchitectureData?.fortigateVlanConfigurations || []);
    const takenSet = new Set();
    source.forEach(item => {
      if (item?.memberType === "VLAN_SWITCH") {
        const vlanVal = (overridePort && overrideVlan && item.port === overridePort)
          ? overrideVlan
          : item?.accessMembers?.vlan;
        if (vlanVal) takenSet.add(vlanVal);
      }
    });
    setVlanSwitchTakenAccessMembers(takenSet);
    return takenSet;
  }, [secureCommunicationData, props?.secureArchitectureData]);

  const handleSelectMemberType = (member, port, type) => {
    // Pre-build a lookup map for securedCommunicationArchitecture VLANs (for MGMT default)
    const vlanLookup = new Map(
      (secureCommunicationData?.securedCommunicationArchitecture || []).map(item => [item.vlan, item])
    );

    const updatedMoxaMemberTypeConfigurations = secureCommunicationData?.[type]?.map((config) => {
      if (port === config.port) {
        // If selecting VLAN_SWITCH ensure default accessMembers points to MGMT VLAN definition
        if (member === "VLAN_SWITCH") {
          const mgmtAccessMember = vlanLookup.get("MGMT") || config.accessMembers;
          return {
            ...config,
            memberType: member,
            accessMembers: mgmtAccessMember,
          };
        }
        if (["HYBRID_TRUNK", "TRUNK"].includes(member)) {
          return {
            ...config,
            memberType: member,
          };
        }
        // All other member types reset hybridMembers array
        return {
          ...config,
          memberType: member,
          hybridMembers: [],
        };
      }
      return config;
    }) || [];
    const hasWAN  = updatedMoxaMemberTypeConfigurations.some(item => item.memberType === "WAN");
    setWanSelected(hasWAN);
    setSecureCommunicationData(prev =>( {
      ...prev,
      [type]: updatedMoxaMemberTypeConfigurations,
    }));
    // Recompute taken VLANs using updated array to avoid stale props
    if(type === 'fortigateVlanConfigurations') {
      computeVlanSwitchTakenAccessMembers(null, null, updatedMoxaMemberTypeConfigurations);
    } else {
      computeVlanSwitchTakenAccessMembers();
    }
  };
  /* istanbul ignore next */
  const handleAccessEnable = (e, port, type) => {
    const updatedMoxaEnableConfigurations = secureCommunicationData?.[type]?.map(
      (config) => {
        if (port === config.port) {
          return {
            ...config,
            enable: e,
          };
        }
        return config;
      }
    );

    setSecureCommunicationData(prev =>({
      ...prev,
      [type]: updatedMoxaEnableConfigurations,
    }));
  };
  /* istanbul ignore next */
  const handleSelectAccessMember = (event, port, type) => {
    const updatedAccessMemberConfigurations = secureCommunicationData[
      type
    ]?.map((config) => {
      let accessMember = { ...config.accessMembers };
      if (port === config.port) {
        let accessMem =
        secureCommunicationData?.securedCommunicationArchitecture;
        const filterMember = accessMem?.filter(
          (data) => data.vlan === event.target.value
        );
        accessMember = filterMember[0];

        return {
          ...config,
          ["accessMembers"]: accessMember,
        };
      } else {
        return {
          ...config,
          ["accessMembers"]: accessMember,
        };
      }
    });
    setSecureCommunicationData(prev=>({
      ...prev,
      [type]: updatedAccessMemberConfigurations,
    }));
    // Recompute taken VLANs after access member change using override & updated configs
    if(type === 'fortigateVlanConfigurations') {
      computeVlanSwitchTakenAccessMembers(port, event.target.value, updatedAccessMemberConfigurations);
    } else {
      computeVlanSwitchTakenAccessMembers(port, event.target.value);
    }
  };
  const getHybridMembers = (members) => {
    const updatedSecureArchitectureData = {
      ...secureCommunicationData,
      moxaVlanConfigurations: members?.moxaVlanConfigurations,
    };
    // setSecureArchitectureData(updatedSecureArchitectureData);
  };
  const dropdownValues = (selectedOption, portSelected, type) => {
    // Normalize selectedOption to array
    const selectedArray = Array.isArray(selectedOption) ? selectedOption : [];
    const originalConfigs = secureCommunicationData?.[type] || [];
    // Determine if selected port currently represents VLAN_SWITCH with MGMT
    const isSelectedVlanSwitchMgmt = originalConfigs?.some(cfg => cfg?.port === portSelected?.port && cfg?.memberType === 'VLAN_SWITCH' && cfg?.accessMembers?.vlan === 'MGMT');

    const updatedConfigurations = originalConfigs?.map(config => {
      if (portSelected?.port === config?.port) {
        // Always update the selected port's hybridMembers with new selection
        return {
          ...config,
          hybridMembers: [...selectedArray],
        };
      }
      // Only clear hybridMembers for OTHER VLAN_SWITCH+MGMT ports
      if (
        config?.memberType === 'VLAN_SWITCH' &&
        config?.accessMembers?.vlan === 'MGMT' &&
        config?.port !== portSelected?.port
      ) {
        return {
          ...config,
          hybridMembers: [],
        };
      }
      return config;
    });

    setSecureCommunicationData(prev => ({
      ...prev,
      [type]: updatedConfigurations,
    }));

    // If fortigate configuration was updated and memberType is VLAN_SWITCH consider recompute (in case selection influences future rules)
    if (type === 'fortigateVlanConfigurations') {
      computeVlanSwitchTakenAccessMembers();
    }
  };
  const callSnackbar = (type, message) => {
    setSnackBar({ type, message });
    document.getElementById("custom-securepage").open = true;
  };
  const handleVlanConfiguration = (e) => {
    const {name, value} = e.target;
    setVlanConfiguration(value);
  }

  // Keep Set in sync when incoming secureArchitectureData changes (e.g., initial load)
  useEffect(() => {
    computeVlanSwitchTakenAccessMembers();
  }, [computeVlanSwitchTakenAccessMembers]);
  return (
    <>
      {loading && <se-loading loading={loading} full-page="true"></se-loading>}
      <div>
        {props?.siteType ? (
          <div>
            <div
              className={
                props?.siteCreated ||
                props?.projectStatusData?.projectStatus === "COMPLETED" ||
                props?.projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
                  ? "se-block-disabled row"
                  : !UserScope.access.saveSystemInfo
                  ? "se-block-disabled row"
                  : "row"
              }
            >
              <div
                className="col-md-12 mt-1"
                style={
                  props?.siteType === embLabels.GENSET_PVBESS_A2E
                    ? { userSelect: "none", pointerEvents: "none" }
                    : {}
                }
              >
                {(props?.siteType === embLabels.ISLANDABLE ||
                  props?.siteType === embLabels.GRID_CONNECTED ||
                  props?.siteType === embLabels.PV_HYBRIDIZATION ||
                  (props?.siteType === embLabels.ISLANDABLE_GSX &&
                    props?.architectureType === embLabels.PV_GENSET_ATS) ||
                  (props?.siteType === embLabels.GRID_CONNECTED_GSX &&
                    props?.architectureType === embLabels.PV_BESS_NR)) && (
                  <>
                   
                    <div className="row mt-2">
                      <div className="col-md-12">
                        <span className="se-font-14px-bold se-life-green">
                          {" "}
                          VLAN Subnet Definitions.
                        </span>

                        <div className="table-responsive mt-2">
                          <SecureTableHeading
                            data={
                              props?.secureArchitectureData?.securedCommunicationArchitecture
                            }
                          />
                          <table className="table table-bordered ">
                            <tbody>
                              {props?.secureArchitectureData?.securedCommunicationArchitecture.map(
                                (data) => (
                                  <SecureCommunicationTable
                                    key={data.id}
                                    data={data}
                                  />
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-1 mb-1 ">
                      <div className="col-sm-12 se-font-14px-bold se-life-green mb-1">
                        Select Configuration Type
                      </div>
                      <div className="col-sm-2 col-md-2 col-lg-2 col-xl-2 mb-2 ">
                        <div className="custom-control custom-radio">
                          <input
                            type="radio"
                            id="vlanConfigurationMoxa"
                            name="vlanConfiguration"
                            className="custom-control-input islandableRadio  asCompatible"
                            checked={vlanConfiguration === "moxa"}
                            onClick={handleVlanConfiguration}
                            value="moxa"
                          />
                          <label
                            className="custom-control-label line-height-25px"
                            htmlFor="vlanConfiguration"
                          >
                            Moxa
                          </label>
                        </div>
                      </div>
                       <div className="col-sm-2 col-md-2 col-lg-2 col-xl-2 mb-2 ">
                        <div className="custom-control custom-radio">
                          <input
                            type="radio"
                            id="vlanConfigurationFortigate"
                            name="vlanConfiguration"
                            className="custom-control-input islandableRadio  asCompatible"
                            checked={vlanConfiguration === "fortigate"}
                            onClick={handleVlanConfiguration}
                            value="fortigate"
                          />
                          <label
                            className="custom-control-label line-height-25px"
                            htmlFor="vlanConfiguration1"
                          >
                            Fortigate
                          </label>
                        </div>
                      </div>
                    </div>
                    { vlanConfiguration === "moxa" ?
                      <>
                      <div className="row">
                        <div className="col-md-12">
                          <span className="se-font-14px-bold se-life-green">
                            {" "}
                            Moxa Port to VLAN Configuration
                          </span>

                          <div className="table-responsive mt-2">
                            <VlanTableHeading headers = {moxaVlanHeaders} />
                            <table className="table table-bordered">
                              <tbody>
                                {props?.secureArchitectureData?.moxaVlanConfigurations.map(
                                  (data) => (
                                    <MoxaCommunicationTable
                                    typeList ={memberTypeList}
                                      key={data.id}
                                      data={data}
                                      communicationType="moxaVlanConfigurations"
                                      handleSelectMemberType={
                                        handleSelectMemberType
                                      }
                                      handleAccessEnable={handleAccessEnable}
                                      handleSelectAccessMember={
                                        handleSelectAccessMember
                                      }
                                      getHybridMembers={getHybridMembers}
                                      secureData={props?.secureArchitectureData}
                                      dropdownValues={dropdownValues}
                                    />
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                   
                      <div className="row">
                        <div className="col-md-12 ">
                          <span className="se-font-14px-bold se-life-green">
                            {" "}
                            Moxa : Connexium VLAN Configurations
                          </span>

                          <div className="table-responsive mt-2">
                            <VlanTableHeading headers = {moxaVlanHeaders} />
                            <table className="table table-bordered">
                              <tbody>
                                {props?.secureArchitectureData?.connexiumVlanConfigurations.map(
                                  (data) => (
                                    <MoxaCommunicationTable
                                   typeList = {memberTypeList}
                                      key={data.id}
                                      data={data}
                                      communicationType="connexiumVlanConfigurations"
                                      handleSelectMemberType={
                                        handleSelectMemberType
                                      }
                                      handleAccessEnable={handleAccessEnable}
                                      handleSelectAccessMember={
                                        handleSelectAccessMember
                                      }
                                      getHybridMembers={getHybridMembers}
                                      secureData={props?.secureArchitectureData}
                                      dropdownValues={dropdownValues}
                                    />
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      </>
                      :
                       <>
                      <div className="row">
                        <div className="col-md-12">
                          <span className="se-font-14px-bold se-life-green">
                            {" "}
                            FortiGate Port to VLAN Configuration
                          </span>

                          <div className="table-responsive mt-2">
                            <VlanTableHeading headers = {fortiGateVlanHeaders}/>
                            <table className="table table-bordered">
                              <tbody>
                                {secureCommunicationData?.fortigateVlanConfigurations?.map(
                                  (data) => (
                                    <MoxaCommunicationTable
                                   typeList = {interfaceTypeListFortigate}
                                      key={data.id}
                                      data={data}
                                      communicationType="fortigateVlanConfigurations"
                                      handleSelectMemberType={
                                        handleSelectMemberType
                                      }
                                      handleAccessEnable={handleAccessEnable}
                                      handleSelectAccessMember={
                                        handleSelectAccessMember
                                      }
                                      getHybridMembers={getHybridMembers}
                                      secureData={secureCommunicationData}
                                      dropdownValues={dropdownValues}
                                      vlanConfigurationType = {vlanConfiguration}
                                      wanSelected = {wanSelected}
                                      // Pass Set converted to array for child consumption plus callback for updates if needed
                                      vlanSwitchTakenAccessMembers={Array.from(vlanSwitchTakenAccessMembers)}
                                    />
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                   
                      <div className="row">
                        <div className="col-md-12 ">
                          <span className="se-font-14px-bold se-life-green">
                            {" "}
                            FortiGate : Connexium VLAN Configurations
                          </span>

                          <div className="table-responsive mt-2">
                            <VlanTableHeading  headers = {fortiGateVlanHeaders}/>
                            <table className="table table-bordered">
                              <tbody>
                                {props?.secureArchitectureData?.connexiumFortigateVlanConfigurations.map(
                                  (data) => (
                                    <MoxaCommunicationTable
                                    typeList = {interfaceTypeListFortigateConexium}
                                      key={data.id}
                                      data={data}
                                      communicationType="connexiumFortigateVlanConfigurations"
                                      handleSelectMemberType={
                                        handleSelectMemberType
                                      }
                                      handleAccessEnable={handleAccessEnable}
                                      handleSelectAccessMember={
                                        handleSelectAccessMember
                                      }
                                      getHybridMembers={getHybridMembers}
                                      secureData={secureCommunicationData}
                                      dropdownValues={dropdownValues}
                                    />
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      </>
                    }





                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                        {/* <se-button
                            option="flat"
                            color="primary"
                            
                          >
                            Save
                          </se-button> */}
                        {
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm se-btn-primary"
                            onClick={saveSecureCommunicationData}
                          >
                            <se-icon size="nano">action_save</se-icon>
                            <span>&nbsp;</span>Save
                          </button>
                        }
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                        <se-snackBar
                          id="custom-securepage"
                          type={snackBar.type}
                          message={snackBar.message}
                          icon="information_stroke"
                          duration="3000"
                        ></se-snackBar>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        ) : (
          <se-loading loading={loading}></se-loading>
        )}
      </div>
    </>
  );
};

export default SecureArchitectureHook;
